module.exports = __webpack_public_path__ + "static/media/blue-tick.d57c1d2a.svg";